export default __webpack_public_path__ + "static/benefitImage6-1651869699eb0fb89b4c4d8367a7a5e9.webp";